module.exports = __webpack_public_path__ + "static/app-6-3b0aab3b4b0cd05525e72c404b1f3317.png";